import { atom } from 'recoil';
import { INivelPosicao } from '../../commons/types/crm';

export const nivelPosicaoAtom = atom<INivelPosicao[]>({
  key: 'nivelPosicao',
  default: [] as INivelPosicao[],
});
